import FormDrawer from 'components/__new/common/form-drawer'
import React from 'react'

const DeletePayStructure = ({isOpen, setIsOpen, onProceed, loading}) => {

    return (
        <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="p-6">
                <FormDrawer.Title
                    title="Delete Pay Structure"
                    showCloseButton={true}
                    close={setIsOpen}
                />
                <div className="w-full">
                    <div className="my-7 text-ep-gray-600">
                        Are you sure you want to perform this action? <br /> This action cannot be undone.
                    </div>
                    <div className="w-full flex items-center justify-start pt-3">
                        <button disabled={loading} onClick={onProceed} type="button" className="btn bg-[#dc2626] text-white w-full mr-3">
                            {loading ? "Deleting..." : "Yes"}
                        </button>
                        <button disabled={loading} onClick={() => setIsOpen(false)} className="btn btn-transparent-primary w-full font-semibold">
                            No
                        </button>
                    </div>
                </div>
            </div>
        </FormDrawer>
    )
}

export default DeletePayStructure;